import React, { useReducer, useEffect } from "react";
import Edit from "./components/Edit";
import Summary from "./components/Summary";
import Modal from "../../../Modal";

import * as StateReducer from "./reducers/stateReducer";

function PlotMetadata(props) {
  const [metadataState, metadataDispatch] = useReducer(StateReducer.reducer, StateReducer.initialState);

  useEffect(() => {
    metadataDispatch({
      type: StateReducer.Action.openEditMetadata,
      payload: props.metadata,
    });
  }, [props, metadataDispatch]);

  const handleClose = () => {
    props.onClose();
  };
  const handleProceed = (data) =>
    metadataDispatch({
      type: StateReducer.Action.openSummaryMetadata,
      payload: data,
    });
  const handleBack = (data) =>
    metadataDispatch({
      type: StateReducer.Action.openEditMetadata,
      payload: data,
    });

  const editMetadata = (
    <Edit
      data={metadataState.metadata}
      onProceed={(data) => {
        handleProceed(data);
      }}
    />
  );

  const summaryMetadata = (
    <Summary
      data={metadataState.metadata}
      onClose={() => handleClose()}
      onBack={handleBack}
      plotData={props.plotData}
    />
  );
  return (
    <Modal onClose={() => handleClose()}>
      {metadataState.displayEditMetadata && editMetadata}
      {metadataState.displaySummaryMetadata && summaryMetadata}
    </Modal>
  );
}

export default PlotMetadata;
